'use client';

import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';

export type CrossLinksSectionProps = {
	className?: string;
	title?: ReactNode;
	cards: ReactNode;
};

export function CrossLinksSection(props: CrossLinksSectionProps) {
	return (
		<article data-component='CrossLinksSection' className={cn('container-xl md:pb-10', props.className)}>
			<div className={`pt-10 pb-5`}>{props.title}</div>
			{props.cards}
		</article>
	);
}
